<template>
  <div>
    <div class="contact">
      <div class="item" @click="onlineMe('/bmtd')">
        <div>
          <img
            src="../assets/images/contact/icon1.png"
            style="width: 19px; height: 20px"
          />
        </div>
        <div class="c6">申请试听</div>
      </div>
      <div class="item" @click="onlineMe('/onlineing')">
        <div>
          <img
            src="../assets/images/contact/icon2.png"
            style="width: 19px; height: 20px"
          />
        </div>
        <div class="c6">在线咨询</div>
      </div>
      <div
        class="item"
        @mouseenter="mouseoverMePhone"
        @mouseleave="phone = false"
      >
        <div>
          <img
            src="../assets/images/contact/icon3.png"
            style="width: 20px; height: 21px"
          />
        </div>
        <div class="c6">电话咨询</div>
      </div>
      <div class="item" @mouseenter="mouseoverMe" @mouseleave="er = false">
        <div>
          <div>
            <img
              src="../assets/images/contact/icon4.png"
              style="width: 23px; height: 20px"
            />
          </div>
          <div class="c6">微信咨询</div>
        </div>
      </div>
      <div class="item" style="border-bottom: 0" @click="toTop('40')">
        <div>
          <img
            src="../assets/images/contact/gotop.png"
            style="width: 14px; height: 8px"
          />
        </div>
        <div class="c6" style="padding-bottom: 0">返回顶部</div>
      </div>
    </div>
    <div class="kefuwx" v-if="er">
      <div>
        <img
          src="http://h5.shihua.com/static/yunxue/fer1.png"
          style="width: 160px; height: 160px"
        />
      </div>
      <div>添加客服微信</div>
    </div>
    <div class="c6 tel" v-if="phone">
      <div class="f16">客服电话</div>
      <div class="f12">13167586989</div>
    </div>
    <div v-if="showMe" class="mask"></div>
    <div class="alertdiv" v-if="showMe">
      <div class="contactbox">
        <i class="el-icon-circle-close guanbi" style="font-size: 25px"></i>
        <div class="hd flex">
          <img
            src="../assets/images/1/logo.png"
            style="width: 144px; height: 45px"
          />
          <div class="f16">
            实战、实效、实操、专注助力企业绩效持续提升
            开课超过3000场，总裁学员突破30万。
          </div>
        </div>
        <div class="p10">
          <div class="te">
            <p>欢迎访问！<span>总裁学堂——世华教育集团</span></p>
            <p style="margin: 10px 0 20px 0">
              我是今天的值班老师<span>胡老师</span>，很高兴为你服务。请问你想要咨询哪方面的问题？
            </p>
            <p style="margin-bottom: 10px">
              为了更好的为您提供服务，您可以<span>选择</span>
            </p>
            <p>1、添加老师<span>微信：datx2021</span>，一对一详细沟通；</p>
            <p>
              2、留下您的<span>联系方式，</span>我们通过电话进行详细沟通，节省您的宝贵时间，同时保证不会打扰到您
            </p>
          </div>
          <div>
            <textarea
              class="_textarea"
              placeholder="请输入..."
              maxlength="300"
              v-model="formdata.content"
            />
          </div>
          <div class="btns">
            <input
              class="f16 c9 inputs"
              style="height: 35px; width: 160px"
              placeholder="输入手机号码"
              maxlength="11"
              type="number"
              v-model="formdata.phone"
              oninput="if(value.length>11)value=value.slice(0,11)"
            />
            <button class="f16 buttons" @click="tapFS" :disabled="isDis">
              发送
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      showMe: false,
      isDis: false,
      er: false,
      phone: false,
      formdata: {
        name: "ml",
        phone: "",
        content: "",
      },
    };
  },
  methods: {
    onlineMe(add){
      this.$router.push({ path: add });
    },
    toTop(step) {
      //参数step表示时间间隔的幅度大小，以此来控制速度
      //当回到页面顶部的时候需要将定时器清除
      document.documentElement.scrollTop -= step;
      if (document.documentElement.scrollTop > 0) {
        var time = setTimeout(() => this.toTop(step), 15);
      } else {
        clearTimeout(time);
      }
    },
    tapShow() {
      this.showMe = !this.showMe;
    },
    mouseoverMePhone() {
      this.phone = !this.phone;
      this.er = false;
    },
    mouseoverMe() {
      this.er = !this.er;
      this.phone = false;
    },
    tapFS() {
      var that = this;
      if (this.formdata.content == "") {
        this.$message({
          message: "请输入咨询内容！",
          offset: 300,
          type: "warning",
        });
        return;
      }
      if (this.formdata.phone.length != "11") {
        this.$message({
          message: "请输入正确手机号码！",
          offset: 300,
          type: "warning",
        });
        return;
      }
      if ((this.formdata.phone + "").substr(0, 1) != "1") {
        this.$message({
          message: "请输入正确手机号码！",
          offset: 300,
          type: "warning",
        });
        return;
      }
      this.isDis = true;
      subMessage(this.formdata).then((res) => {
        console.log(res);
        this.$message({
          message: "提交成功，客服会尽快联系您！",
          offset: 300,
          type: "success",
        });
        this.isDis = false;
        this.showMe = false;
      });
    },
  },
};
</script>
<style scoped>
.kefuwx {
  position: fixed;
  right: 180px;
  top: 45%;
  padding-bottom: 10px;
  cursor: pointer;
  background: #ffffff;
  margin-top: 150px;
  text-align: center;
  z-index: 99999999999;
}
.contact {
  position: fixed;
  right: 80px;
  top: 45%;
  width: 80px;
  cursor: pointer;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 0px 20px 0px rgba(19, 69, 125, 0.15);
  z-index: 1000;
  text-align: center;
  padding: 10px;
}
.contactbox .buttons:disabled {
  background: #ccc;
}
.contact .item {
  border-bottom: 1px solid #dcdcdc;
  margin-bottom: 10px;
}
.contact .item .c6 {
  padding: 0;
  font-size: 12px;
  padding: 10px 0 10px 0;
}
.tel {
  position: fixed;
  z-index: 99999999999;
  right: 180px;
  top: 65%;
  padding: 10px;
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.11);
}
.contact .item .c6:hover {
  color: #25a2dd;
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue